// extracted by mini-css-extract-plugin
export default {"root":"Loading-module__root___zdOWH","message":"Loading-module__message___mCLH+","icon":"Loading-module__icon___UNClj","cycle":"Loading-module__cycle___E+40d"};